import Swiper from 'swiper';
// import swiper css
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';

function imageGallery() {
    const imageGalleryPortrait = document.querySelectorAll('.image-gallery-portrait');
    const imageGalleryLandscapeTop = document.querySelectorAll('.image-gallery-landscape-top');
    const imageGalleryLandscapeBottom = document.querySelectorAll('.image-gallery-landscape-bottom');
    const imageGalleryMobile = document.querySelectorAll('.image-gallery-mobile');

    // Image Gallery Portrait
    if (imageGalleryPortrait.length > 0) {
        // Starting point
        imageGalleryPortrait.forEach((imageGallery) => {

            function initializeSwiper() {

                let swiper = new Swiper(imageGallery, {
                    modules: [ Navigation ],
                    navigation: {                       
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    loop: true,
					speed: 800,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerColumn: 1,
                });
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }

    // Image Gallery Landscape Top
    if (imageGalleryLandscapeTop.length > 0) {
        // Starting point
        imageGalleryLandscapeTop.forEach((imageGallery) => {

            function initializeSwiper() {

                let swiper = new Swiper(imageGallery, {
                    modules: [ Navigation ],
                    navigation: {                       
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    loop: true,
					speed: 800,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerColumn: 1,
                });
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }

    // Image Gallery Landscape Bottom
    if (imageGalleryLandscapeBottom.length > 0) {
        // Starting point
        imageGalleryLandscapeBottom.forEach((imageGallery) => {

            function initializeSwiper() {

                let swiper = new Swiper(imageGallery, {
                    modules: [ Navigation ],
                    navigation: {                       
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    loop: true,
					speed: 800,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerColumn: 1,
                });
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }

    // Image Gallery Mobile
    if (imageGalleryMobile.length > 0) {
        // Starting point
        imageGalleryMobile.forEach((imageGallery) => {

            function initializeSwiper() {

                let swiper = new Swiper(imageGallery, {
                    modules: [ Navigation ],
                    navigation: {                       
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    loop: true,
					speed: 800,
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    slidesPerColumn: 1,
                    spaceBetween: 25,
                    loopAdditionalSlides: 10,
                });
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }
}

export default imageGallery;